<div class="sidebar-logo">
  <a href="/" class="brand-wrapper">
    <img src="/images/OCELUS-Logo-02.svg" alt="logo" *ngIf="!isCollapsed" class="logo-expanded">
    <!-- [ngClass]="isCollapsed ? 'logo-collapsed' : 'logo-expanded'" -->
     <!-- [ngClass]="isCollapsed ? 'logo-collapsed' : 'logo-expanded'" -->
    <img src="/images/OCELUS Logo 02.svg" alt="logo" *ngIf="isCollapsed" class="logo-collapsed">
    
  </a>
</div>

<div
  *ngIf="isDevEnvironment"
  class="env-badge"
  [class.env-badge-collapsed]="isCollapsed"
  nz-tooltip
  nzTooltipPlacement="right"
  nzTooltipTitle="Development Environment"
>
  <span class="env-badge-dot"></span>
  <span class="env-badge-text" *ngIf="!isCollapsed">DEV ENVIRONMENT</span>
</div>

<!--
<div 
  class="search-menu" [ngClass]="{'search-collapsed': isCollapsed}"
  (click)="openMasterSearch()"
  nz-tooltip
  nzTooltipPlacement="right"
  [nzTooltipTitle]="isCollapsed ? 'Search' : ''"
>
  <i nz-icon [nzType]="'search'"></i>
  <span>Search</span>
</div>
-->



<ul class="menu-list" nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
  <!-- Search Option as Menu Item -->
  <li
    nz-menu-item
    class="search-menu-item no-select-item"
    (click)="openMasterSearch()"
    nz-tooltip
    nzTooltipPlacement="right"
    [nzTooltipTitle]="isCollapsed ? 'Search' : ''"
  >
    <i nz-icon [nzType]="'search'"></i>
    <span>Search</span>
  </li>

<!-- <li
  nz-menu-item
  class="search-menu-item no-select-item"
  (click)="openMasterSearch()"
  nz-tooltip
  nzTooltipPlacement="right"
  [nzTooltipTitle]="isCollapsed ? 'Search' : ''"
>
  <i nz-icon [nzType]="'search'"></i>
  <span>Search</span>
</li> -->

  <!-- Dashboard Menu Item -->
  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngFor="let item of MENU_ITEMS_DASHBOARD" nz-tooltip
    nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? item.label : ''">
    <a [routerLink]="item.link">
      <i nz-icon [nzType]="item.icon"></i>
      <span>{{item.label}}</span>
    </a>
  </li>


  <!-- Console Menu Item -->
  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngFor="let item of MENU_ITEMS_CONSOLES" nz-tooltip
    nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? item.label : ''">
    <a [routerLink]="item.link">
      <i nz-icon [nzType]="item.icon"></i>
      <span>{{item.label}}</span>
    </a>
  </li>

   
  
     <!-- Action Menu Item -->
     <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngFor="let item of COMPONENTS_ITEMS"
     nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? item.label : ''">
      <a [routerLink]="item.link">
        <i nz-icon [nzType]="item.icon"></i>
        <span>{{item.label}}</span>
      </a>
    </li>

  <!-- "Components" Submenu -->
  <!-- <li nz-submenu nzTitle="Components" nzIcon="appstore">
    <ul>
      <li nz-menu-item *ngFor="let item of COMPONENTS_ITEMS" [routerLinkActive]="['ant-menu-item-selected']">
        <a [routerLink]="item.link">
          <i nz-icon [nzType]="item.icon"></i>
          <span>{{item.label}}</span>
        </a>
      </li>
    </ul>
  </li> -->

  <!-- Reports Menu Item -->
  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngFor="let item of REPORTS_ITEMS" nz-tooltip
    nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? item.label : ''">
    <a [routerLink]="item.link">
      <i nz-icon [nzType]="item.icon"></i>
      <span>{{item.label}}</span>
    </a>
  </li>

   <!-- Action Menu Item -->
    <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngFor="let item of MENU_ITEMS_ACTIONS"
    nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? item.label : ''">
      <a [routerLink]="item.link">
        <i nz-icon [nzType]="item.icon"></i>
        <span>{{item.label}}</span>
      </a>
    </li>

  <!-- Settings Menu Item -->
  <li nz-menu-item [routerLinkActive]="['ant-menu-item-selected']" *ngFor="let item of SETTINGS_ITEMS" nz-tooltip
    nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? item.label : ''">
    <a [routerLink]="item.link">
      <i nz-icon [nzType]="item.icon"></i>
      <span>{{item.label}}</span>
    </a>
  </li>



</ul>





<app-master-search [isVisible]="showMasterSearch" (closeModal)="closeMasterSearch()"></app-master-search>